import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { StreamListComponent } from './stream-list/stream-list.component';
import { StreamCreateComponent } from './stream-create/stream-create.component';


const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list',
        component: StreamListComponent,
        data: {
          title: "Stream List",
          breadcrumb: "Stream List"
        }
      },
      {
        path: 'create',
        component: StreamCreateComponent,
        data: {
          title: "Create Stream",
          breadcrumb: "Create Stream"
        }
      },
      {
        path: 'edit/:id',
        component: StreamCreateComponent,
        data: {
          title: "Edit Stream",
          breadcrumb: "Edit Stream"
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class StreamRoutingModule { }
